'use client'

import React from 'react'
import Image from 'next/image'
import { Text } from '@quark/typography'
import { Flex } from '@quark/layout'
import styles from './spotlight.module.scss'

export const NewsCard = ({ card }) => (
  <div className={styles.newsCard} onClick={() => window?.open(card?.redirectionUrl, '_blank')}>
    <div className={styles.newsDetails}>
      <Image alt="card-logo" src={card?.iconUrl?.url} width={24} height={20} />
      <Text as="p" fontStyle="um_text-xl/normal" color="base/secondary">
        {card?.dateString}
      </Text>
    </div>
    <div className={styles.newsImageContainer}>
      <Image alt="card-image" src={card.heroImage?.url} width={410} height={280} />
    </div>
    <div className={styles.newsContentContainer}>
      <Flex flexDirection="column" gap="spacing-16">
        <Text as="p" fontStyle="um_text-2xl/bold" color="base/primary">
          {card?.heading}
        </Text>
        <Text as="p" fontStyle="um_text-xl/normal" color="base/primary">
          {card?.description}
        </Text>
      </Flex>
      <div className={styles.icon} />
    </div>
  </div>
)
